import { takeLatest, fork } from "redux-saga/effects";
import { clearData, logout } from "../Slice/LogoutSlice";
import { clearClientAuthSession } from "../../utils/authCookie";
import { clearPhiFromBrowserStorage } from "../../utils/patientSession";
import { clearSearchHistory } from "../../utils/AIPrescription/searchHistoryUtils";
import { clearConversationState } from "../../utils/AIPrescription/conversationUtils";
import { clearPrescriptionFlags } from "../../utils/AIPrescription/prescriptionFlagsStore";
import { clearSessionBenefitSource } from "../../utils/AIPrescription/sessionBenefitSourceStore";
import { clearPrescriptionEdits } from "../../utils/AIPrescription/prescriptionEditsStore";

function onLoadLogoutAsync({ payload }: any) {
  // NOTE: The `logout` action that triggered this saga already set isLogin=false
  // in the reducer (see LogoutSlice). Do NOT re-dispatch `logout` here — under
  // takeLatest, dispatching the watched action cancels this running task at the
  // `yield put`, so the cleanup below would never run. That left the held
  // conversation + orchestration session id intact, so the previous session
  // reappeared on the next login. Cleanup runs in `finally` so it always fires.
  try {
    const element = document.querySelector(
      ".ChatbotfloatIcon"
    ) as HTMLInputElement | null;
    if (element) {
      element.style.display = "none";
    }
  } catch (err) {
    // Hiding the icon is best-effort; cleanup must still run.
  } finally {
    clearPhiFromBrowserStorage();
    clearSearchHistory();
    clearConversationState();
    clearPrescriptionFlags();
    clearSessionBenefitSource();
    clearPrescriptionEdits();
    window.localStorage.clear();
    clearClientAuthSession();
    sessionStorage.clear();
    payload.history("/", { replace: true });
    window.location.reload();
  }
}

function* onLoadLogout() {
  yield takeLatest(logout.type, onLoadLogoutAsync);
}

const LogoutSaga = [fork(onLoadLogout)];

export default LogoutSaga;
